export function extractDifference(original, updated) {
    const diff = {};
    for (const key in original) {
        if (updated[key] && 
            original[key] !== updated[key]
        ){
            diff[key] = updated[key]
        }
    }

    return diff;
}